shvenergy.trackingQueries = (function ($) {
    "use strict";

    document.addEventListener('click', function (event) {
        trackClickEvent(event);
    });

    document.addEventListener('auxclick', function (event) {
        trackClickEvent(event);
    });

    function trackClickEvent(event) {
        var isLink = event.target.closest("a") !== null || event.target.nodeName === "A";
        var trackingOriginalClickedElement = event.target.nodeName;
        var trackingPageName = document.title;
        var moduleName = "";

        if (isLink) {
            var link = null;
            if (event.target.nodeName === "A") {
                link = event.target;
            } else {
                link = event.target.closest("a");
            }

            var trackingText = link.innerText.replace('\t', '');
            var isButton = link.classList.contains("button");
            var trackingFunction = link.dataset.trackingfunction || "";
            var trackingUrl = link.getAttribute("href") || "";
            var documentTracking = link.dataset.trackingdocname || "";
            var moduleNameElement = link.closest("[data-trackingmodulename]");

            if (moduleNameElement !== undefined && moduleNameElement  !== null) {
                moduleName = moduleNameElement.dataset.trackingmodulename;
            }

            if (
                window.trackingVariables !== undefined
                && window.trackingVariables !== null
                && window.trackingVariables.type !== "Content page"
            ) {
                trackingPageName = window.trackingVariables.type;
            }

            shvenergy.tracking.trackRawEventData({
                event: "clickLink",
                linkName: trackingText,
                pageName: trackingPageName,
                type: trackingOriginalClickedElement,
                function: trackingFunction,
                url: trackingUrl,
                docName: documentTracking,
                moduleName: moduleName
            });
        }
    }

})(jQuery);